import clsx from 'clsx'
import React from "react"
import { ListboxButton, ListboxOption } from '@headlessui/react'

import { ListBox } from '../../lib/fragments/ListBox'
import { displayStylesArray } from '../../utils/Constants'
import { ToggleSwitch } from '../../components/utils/ToggleSwitch'

export const AttributeRestrictions = ({ state, setstate, onInputBlur, onChangeHandler, onListBoxHandler }) => {
    const toogleSwitchHandler = (e: any) => {
        let { input, posting } = state
        if (posting) return

        switch (e.target.name) {
            case 'multiline':
                if (input.format?.key !== 'freetext') return
                break;

            default:
                break;
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                [e.target.name]: e.target.checked
            }
        }))
    }

    return (
        <React.Fragment>
            <div className={clsx(
                "transition-all duration-300 my-3 ease-in-out overflow-hidden rounded-md",
                state.input.format ? "opacity-100" : "max-h-0 opacity-0"
            )}>
                <p className='label flex items-center text-slate-700 dark:text-slate-300 text-base'>
                    Restrictions
                </p>

                <div className="transition-all duration-300 ease-in-out overflow-hidden rounded-md">
                    <div className={clsx(
                        "w-full pt-2",
                        ["predefined"].includes(state.input.format?.key) ? "block" : "hidden"
                    )}>
                        <span className="block text-sm text-slate-800 dark:text-slate-300 pb-1">
                            Display Style <sub className="text-red-500 dark:text-red-500 text-sm">*</sub>

                            <span className="block text-xs text-slate-500 dark:text-slate-300 pb-1">
                                Specify the input's visual style and interaction type
                            </span>
                        </span>

                        <div className="pt-2 px-1 w-full md:w-3/5">
                            <ListBox
                                value={state.input.display_style ? state.input.display_style?.key : ''}
                                eventHandler={(e: any) => onListBoxHandler(e, 'display_style')}
                                button={
                                    <ListboxButton className="relative border w-full rounded-md py-2 pr-2 text-left cursor-default focus:ring-primary focus:border-primary sm:text-sm ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border-slate-300 dark:border-slate-600 dark:text-white">
                                        <div className="flex w-full items-center align-middle">
                                            <div className="flex-grow flex items-center">
                                                <span className="truncate ml-3 font-normal group-data-[selected]:font-semibold">
                                                    {
                                                        state.input.display_style ? (
                                                            <div className="flex items-center gap-x-4">
                                                                <span className="truncate group-data-[selected]:font-semibold">
                                                                    {state.input.display_style?.label}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                Display Style
                                                            </>
                                                        )
                                                    }
                                                </span>
                                            </div>

                                            <span className="fa-light fa-chevron-down focus:text-primary float-end"></span>
                                        </div>
                                    </ListboxButton>
                                }
                                options={
                                    <>
                                        {
                                            displayStylesArray.map((displayStyle: any) => (
                                                <ListboxOption key={`attr-display-style-${displayStyle.key}`} value={displayStyle} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                                    <div className="flex items-center gap-x-4">
                                                        <span className="truncate group-data-[selecteßd]:font-medium">
                                                            {displayStyle.label}
                                                        </span>
                                                    </div>

                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                        <span className="fa-light fa-check"></span>
                                                    </span>
                                                </ListboxOption>
                                            ))
                                        }
                                    </>
                                }
                            />
                        </div>

                        {
                            state.errors.display_style.length > 0 && (
                                <span className='invalid-feedback text-xs text-red-600 dark:text-red-400 pl-1 pt-1'>
                                    {state.errors.display_style}
                                </span>
                            )
                        }
                    </div>

                    <div className="w-full py-3">
                        <ToggleSwitch
                            name={'multiline'}
                            label={'Multi-line Input'}
                            checked={state.input.multiline}
                            changeHandler={toogleSwitchHandler}
                            description={"Allow users to write longer responses"}
                            disabled={state.input.format?.key === 'freetext' ? false : true}
                        />
                    </div>

                    <div className="w-full py-3">
                        <ToggleSwitch
                            label={'Required?'}
                            name={'mandatory'}
                            checked={state.input.mandatory}
                            changeHandler={toogleSwitchHandler}
                            description={"Ensures a value is provided before submitting"}
                        />
                    </div>

                    <div className={clsx(
                        "w-full flex md:flex-row flex-col align-middle md:items-center md:gap-x-3 gap-y-3 py-3",
                        ["freetext"].includes(state.input.format?.key) ? "block" : "hidden"
                    )}>
                        <div className="flex-1">
                            <span className='label text-slate-800 dark:text-slate-200 disabled:text-slate-600 text-sm'>
                                Text length
                            </span>

                            <span className="block text-xs text-slate-500 dark:text-slate-300 pb-1">
                                Set a character limit
                            </span>
                        </div>

                        <div className="md:w-64 flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                            <input
                                type="number"
                                name="minimum"
                                placeholder="Min"
                                onBlur={onInputBlur}
                                onChange={onChangeHandler}
                                value={state.input.minimum}
                                className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                            />

                            <div className="w-px h-6 bg-gray-300 mx-1"></div>

                            <input
                                type="number"
                                name="maximum"
                                placeholder="Max"
                                onBlur={onInputBlur}
                                onChange={onChangeHandler}
                                value={state.input.maximum}
                                className="w-full px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-none"
                            />
                        </div>
                    </div>

                    {
                        state.errors.minimum.length > 0 && (
                            <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pl-1 pt-1'>
                                {state.errors.minimum}
                            </span>
                        )
                    }

                    {
                        state.errors.maximum.length > 0 && (
                            <span className='invalid-feedback text-xs block text-red-600 dark:text-red-400 pl-1 pt-1'>
                                {state.errors.maximum}
                            </span>
                        )
                    }
                </div>
            </div>
        </React.Fragment>
    )
}